<template>
  <div v-if="isWelcomeLogin">
    <div class="col-sm-12 header-component mb15 flex-row plr16">
      <skip-login :skip-text="getSkipLoginText" />
    </div>
    <div class="plr16">
      <!-- <div
        class="login-welcome mb5"
        :class="{
          'mt5 d-flex justify-content-between': clientPlatform == 'Web',
        }"
      >
        <span>{{ loginProps?.headingText }}</span>
        <span v-if="clientPlatform == 'Web'" class="hand">
          <i
            @click.stop="closeWelcomeLoginModal($event)"
            class="hkfi-close"
          ></i>
        </span>
      </div>
      <div class="login-benefit-text">
        {{ loginProps?.subHeadingText }}
      </div> -->
      <div>
        <img :src="staticImgBaseUrl + '/images/global/loginLogoHK.svg'" />
      </div>

      <div class="login-benefit-container">
        <div class="login-benefit-item">
          <i
            :class="loginProps?.loginBenefit1Icon"
            class="fs-24 color-grey-light"
          ></i>
          <div class="login-benefit-text-sm item-1">
            {{ loginProps?.loginBenefit1Text }}
          </div>
        </div>
        <div class="login-benefit-item">
          <i
            :class="loginProps?.loginBenefit2Icon"
            class="fs-24 color-grey-light"
          ></i>
          <div class="login-benefit-text-sm item-2">
            {{ loginProps?.loginBenefit2Text }}
          </div>
        </div>
        <div class="login-benefit-item">
          <i
            :class="loginProps?.loginBenefit3Icon"
            class="fs-24 color-grey-light"
          ></i>
          <div class="login-benefit-text-sm item-3">
            {{ loginProps?.loginBenefit3Text }}
          </div>
        </div>
      </div>
    </div>
    <hr class="mb0 mt0 mlr0" />
  </div>
</template>

<script>
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import { clientPlatform, staticImgBaseUrl } from "../config/apiEndpoints";
import { LoginStates } from "../helpers/loginStateConstants";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { getVwoExperimentsPromiseArray } from "../helpers/vwoSetup";
import fingerPrintInstance from "../store/storeInitializer/initialiseFingerprint";
import { collectData } from "../helpers/fingerPrintHelper";
import { initializeMoEngageTime } from "../helpers/moengageEvents";
import { VWO_HOMEPAGE_EXPERIMENT } from "../config/vwoKeys";
import Utility from "../helpers/utility";
import {
  loadAmplitudeUnsentEvents,
  EVENT_PAGEVIEW_LOGINPAGE,
} from "../helpers/analyticsEvents";
import SkipLogin from "./SkipLogin.vue";
import { initializeMetaTime } from "../helpers/metaEvents";
import PageNames from "../config/pageNames";

export default {
  name: "LoginInfo",
  components: { SkipLogin },
  props: ["moduleProps", "propsData"],
  data() {
    return { modulePropsData: {}, clientPlatform, staticImgBaseUrl };
  },
  async mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    // let fetchedVwoData = {};
    // await Promise.all([...getVwoExperimentsPromiseArray()])
    //   .then((data) => {
    //     data.forEach((element) => {
    //       for (let key in element) {
    //         fetchedVwoData[key] = element[key];
    //       }
    //     });
    //     this.$store.commit(
    //       keyMapsMutation.UPDATE_VWO_EXPERIMENTS,
    //       fetchedVwoData
    //     );
    //   })
    //   .catch((errors) => {});

    // loadAmplitudeUnsentEvents(fetchedVwoData[VWO_HOMEPAGE_EXPERIMENT]);

    loadAmplitudeUnsentEvents(PageNames.HONGS_LOGIN_PAGE);
    const { getFPInstance } = fingerPrintInstance;
    collectData({ detector: getFPInstance() }).then((response) => {
      const payload = {
        detectorData: response,
      };
      this.$store.dispatch(keyMapsAction.SEND_FINGER_PRINT, payload);
    });

    if (!LocalStorageFunc.accessToken()) {
      this.$store.dispatch(keyMapsAction.ANONYMOUS_USER_API, {});
    } else {
      this.$store.commit(
        keyMapsMutation.UPDATE_CURRENT_LOGIN_STATE,
        LoginStates.welcomeLogin
      );
    }
    setTimeout(() => {
      initializeMoEngageTime();
      initializeMetaTime();
    }, 5000);

    Utility.osBackButtonFunc();
    EVENT_PAGEVIEW_LOGINPAGE();
  },
  methods: {
    closeWelcomeLoginModal(e) {
      e.stopPropagation();
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_WELCOME_SCREEN_ON_PAGELOAD,
        false
      );
      if (clientPlatform == "Web") {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_PROFILE_DRAWER_MODAL,
          false
        );
      }
      document.body.classList.remove("body-stop-scroll-mobile");
    },
  },
  computed: {
    showWelcomeLoginModal() {
      return this.$store.state.Auth.showWelcomeScreenOnPageLoad;
    },
    isWelcomeLogin() {
      return clientPlatform == "Web"
        ? this.$store.state.Auth.currentLoginState ===
            LoginStates.welcomeLogin &&
            this.$store.state.Auth.showProfileDrawerModal
        : this.$store.state.Auth.currentLoginState === LoginStates.welcomeLogin;
    },
    loginProps() {
      return Object.keys(this.modulePropsData).length
        ? this.modulePropsData
        : this.$store.state.Auth.loginProps;
    },
    getSkipLoginText() {
      return "Skip";
      // if (!LocalStorageFunc.getSessionStorageKey("previousScreenName", "")) {
      //   return "Skip";
      // } else {
      //   return "Cancel";
      // }
    },
  },
};
</script>
